import { useEffect, useState } from 'react';

/**
 * Updates debounced value once the delay has passed.
 * If the delay has not passed, the timer is reset and the
 * debounced value is not updated.
 */
export function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const timer = setTimeout(() => setDebouncedValue(value), delay || 500);

        return () => {
            clearTimeout(timer);
        };
    }, [value, delay]);

    return debouncedValue;
}
